<div class="flex content-center poll-container" style="margin-bottom: 20px;">

  <div id="status" style="min-height: 50px;">
    <div class="flex flex-row gap-10 align-items-center content-center h-full">
      <p *ngIf="status" class="success-message green flex flex-row gap-10 align-items-center"><img
          src="assets/success-icon.svg" class="icon-inline">Scrutin conforme.</p>
      <p *ngIf="!status" class="success-message red flex flex-row gap-10 align-items-center"><img
          src="assets/failure-icon.svg" class="icon-inline">Scrutin non conforme.</p>
    </div>
  </div>
</div>